var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChangeActive = function SvgChangeActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#FF9500",
    rx: 10.435
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24 36c-6.553 0-12-5.435-12-12 0-6.553 5.435-12 11.988-12C30.553 12 36 17.447 36 24c0 6.565-5.435 12-12 12m.035-18.823c-1.517 0-3.035.529-4.082 1.388-.588.47-.718 1.106-.294 1.553.412.459.976.376 1.459.023.87-.67 1.74-1.047 2.917-1.047 2.412 0 4.412 1.624 4.953 3.777h-1.353c-.564 0-.682.54-.376.976l1.965 2.73c.329.446.894.482 1.247 0l1.94-2.73c.307-.435.2-.976-.376-.976h-1.211c-.6-3.377-3.33-5.694-6.789-5.694m.024 13.6c1.517 0 3.035-.53 4.082-1.4.588-.46.73-1.095.294-1.542-.423-.459-.976-.388-1.458-.023-.871.67-1.742 1.035-2.918 1.035-2.412 0-4.412-1.623-4.953-3.765h1.27c.577 0 .695-.54.389-.976l-1.977-2.741c-.317-.447-.882-.47-1.235 0l-1.941 2.74c-.306.436-.2.977.376.977h1.283c.588 3.377 3.329 5.694 6.788 5.694"
  })));
};
export default SvgChangeActive;